import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/* Visible on every signed-in screen. The click ends the server session, then leaves the page. */
export default function SignOutButton() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <button
      type="button"
      data-testid="sign-out-button"
      className="fixed bottom-4 right-4 z-[70] rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground shadow"
      onClick={() => logout({ navigate })}
    >
      Sign out
    </button>
  );
}
